import { gql } from '@lcs/shared/api';

export const deleteFileMutation = gql`
   mutation DeleteFile($fileId: UInt!) {
      deleteFile(id: $fileId)
   }
`;
